import { RobotHappyIcon } from './RobotHappyIcon';

/**
 * author: Colton Wiscombe
 * id 6AE4D050-1B64-4AAB-B57B-DD738276E82F
 * name robot-happy
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-happy.svg
 * tags
 */
export const EmoticonRobotHappyIcon = RobotHappyIcon;
export default EmoticonRobotHappyIcon